import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import { environment } from 'src/environments/environment';
import { GoogleAuthService } from 'src/app/services/google-auth.service';
import { localStorageService } from 'src/app/services/localstorage.service';

declare var google: any;
declare var client: any;
@Component({
  selector: 'app-google-sign-in',
  templateUrl: './google-sign-in.component.html',
  styleUrl: './google-sign-in.component.scss'
})
export class GoogleSignInComponent implements OnInit {
  @Input() country_id: number = 1;
  @Input() currency_id: number = 1;
  public env = environment;
  private client: any;
  constructor(private main: MainService, private _local: localStorageService, private router: Router) { }

  get googleButtonText(): string {
    return this.router.url.includes('/login') ? 'Sign In with Google' : 'Sign Up with Google';
  }

  async ngOnInit() {
    try {
      setTimeout(async () => {
        await this.initClient();
      }, 1500)
    } catch (error) {
      console.error('Error initializing Google client:', error);
    }
  }

  public socialSignIn(): void {

    if (this._local.getCookie('g_state')) {
      this._local.deleteCookie('g_state');
    }
    // if (google && google.accounts && google.accounts.oauth2) {
    //   // this._googleAuth.googelSignIn();
    //   client = google.accounts.id.initialize({
    //     client_id: this.env.google_client_id,
    //     scope: 'email profile openid',
    //     callback: (tokenResponse: any) => {
    //         console.log('tokenResponsetokenResponse for google return email', tokenResponse);
    //     },
    //     error_callback: (error: any) => {
    //       console.error('OAuth Error22222:', error);
    //     },
    //     use_fedcm_for_prompt: true,
    //     data_use_fedcm_for_prompt: true
    //   });
    // }
    client = google.accounts.oauth2.initTokenClient({
      client_id: this.env.google_client_id,
      scope: 'email profile openid',
      callback: async (tokenResponse: any) => {
        console.log('login tokenResponse ------', tokenResponse);
        const user = await this.main.getUserInfo(tokenResponse.access_token);
        // console.log('user ------', user);
        if (user.email && user.email_verified) {
          const userData = {
            doctor_name: user.name,
            doctor_email: user.email,
            doctor_image: user.picture,
            country_id: this.country_id,
            currency_id: this.currency_id,
            doctor_password: '',
            google_id: user.id || user.sub
          }
          this.main.registerUser(userData);
        }
      },
      error_callback: (error: any) => {
        console.error('OAuth Error:', error);
      },
      use_fedcm_for_prompt: true
    });

    client.requestAccessToken();

    // client.callback = async (tokenResponse: any) => {
    //   console.log('login tokenResponse ------', tokenResponse);
    //   const user = await this.main.getUserInfo(tokenResponse.access_token);
    //   // console.log('user ------', user);
    //   if (user.email && user.email_verified) {
    //     const userData = {
    //       doctor_name: user.name,
    //       doctor_email: user.email,
    //       doctor_image: user.picture,
    //       country_id: this.country_id,
    //       currency_id: this.currency_id,
    //       doctor_password: '',
    //       google_id: user.id || user.sub
    //     }
    //     this.main.registerUser(userData);
    //   }
    // };
  }

  public async initClient(): Promise<void> {
    return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
          if (google && google.accounts){
            client = google.accounts.id.initialize({
                client_id: this.env.google_client_id,
                scope: 'email profile openid',
                callback: (tokenResponse: any) => {
                    console.log('tokenResponsetokenResponse for google return email', tokenResponse);
                },
                error_callback: (error: any) => {
                  console.error('OAuth Error22222:', error);
                },
                use_fedcm_for_prompt: true
            });
          }
          clearInterval(interval);
          resolve();
        }, 100);

        setTimeout(() => {
            clearInterval(interval);
            reject('Google API script load timeout');
        }, 10000); // 10 seconds timeout
    });
}
}
